import GradientBackground from '../GradientBackground/GradientBackground';

export const DetailsHeaderInternal = () => {
  return (
    <div className="relative flex items-center h-16 sm:h-20 md:h-[125px] px-4 sm:px-6 md:px-[60px]">
      <GradientBackground />
      <h1 className="z-10 text-2xl sm:text-3xl md:text-[40px] font-normal">Report</h1>
    </div>
  );
};
